gsap.registerPlugin(ScrollTrigger);
// ==================================================================================== SECTION 1
gsap.set('.co-collection-banner-media-frame img', { top: "0%", transition: 0 });
gsap.to('.co-collection-banner-media-frame img', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-collection-banner', start:'top top', end: "bottom top", scrub: 1.05
  },
  top: "-5%"
});